module.exports = __webpack_public_path__ + "static/media/helper-woocommerce-3.3fb0efb6.png";